import {CustomFieldDefEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {CustomFieldDefAction} from "./CustomFieldDefActionMenu";
import {useCustomFieldDefMutation} from "../../../hooks/useCustomFieldDefMutation";

export type UseCustomFieldDefActionProps = {}

export type UseCustomFieldDefActionResult = {
  onCustomFieldDefActionClick: (customFieldDef: CustomFieldDefEntity, action: CustomFieldDefAction) => void;
}

export const useCustomFieldDefAction = (props: UseCustomFieldDefActionProps = {}): UseCustomFieldDefActionResult => {
  const {} = props

  const navigate = useNavigate();

  const {
    deleteCustomFieldDef,
  } = useCustomFieldDefMutation()

  const _onCustomFieldDefActionClick = useCallback((customFieldDef: CustomFieldDefEntity, action: CustomFieldDefAction) => {
    if (action === "EDIT") {
      navigate(`/custom-field-defs/form`, {state: {id: customFieldDef.id}})
    } else if (action === "DELETE") {
      deleteCustomFieldDef(customFieldDef.id, undefined)
    }
  }, [navigate, deleteCustomFieldDef])

  return {
    onCustomFieldDefActionClick: _onCustomFieldDefActionClick
  }
}
